import { render, staticRenderFns } from "./CategoryFactorPhotos.vue?vue&type=template&id=4fe2dea8&"
import script from "./CategoryFactorPhotos.vue?vue&type=script&lang=js&"
export * from "./CategoryFactorPhotos.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFactorPhotos.vue?vue&type=style&index=0&id=4fe2dea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports